import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRecalcOutsideIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M3 19q9-8 18 0M7 15V9M5 11l2-2 2 2M12 12V5M10 7l2-2 2 2M17 15V9M15 11l2-2 2 2" })
});
export default SvgRecalcOutsideIcon;
